import { Capacitor } from "@capacitor/core";
import { Geolocation } from "@capacitor/geolocation";

const LOCATION_MESSAGE = "Location permission is required for security audit to help detect unauthorized or suspicious login attempts.";

const normalize = (coords) => ({
  latitude: Number(coords.latitude),
  longitude: Number(coords.longitude),
  accuracy: Number(coords.accuracy || 0),
  captured_at: new Date().toISOString(),
  source: Capacitor.isNativePlatform() ? "GPS_APP" : "GPS_WEB",
});

export async function captureRequiredClientLoginLocation() {
  try {
    if (Capacitor.isNativePlatform()) {
      let permission = await Geolocation.checkPermissions();
      if (permission.location !== "granted" && permission.coarseLocation !== "granted") {
        permission = await Geolocation.requestPermissions({ permissions: ["location", "coarseLocation"] });
      }
      if (permission.location !== "granted" && permission.coarseLocation !== "granted") {
        throw new Error(LOCATION_MESSAGE + " Please allow Location in app settings and try again.");
      }
      const pos = await Geolocation.getCurrentPosition({ enableHighAccuracy: true, timeout: 15000, maximumAge: 0 });
      return normalize(pos.coords);
    }

    if (!navigator.geolocation) throw new Error(LOCATION_MESSAGE + " Location is not available in this browser/device.");
    const pos = await new Promise((resolve, reject) => navigator.geolocation.getCurrentPosition(resolve, reject, {
      enableHighAccuracy: true, timeout: 15000, maximumAge: 0,
    }));
    return normalize(pos.coords);
  } catch (e) {
    if (String(e?.message || "").includes("Location permission is required")) throw e;
    throw new Error(LOCATION_MESSAGE + " Please enable Location and try again.");
  }
}
